module.exports = __webpack_public_path__ + "img/sdc_pic_4.93be1884.jpg";